import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IDeleteOIDCConfigurationParams {
  idpConfigurationId: string;
}

export class DeleteOIDCConfigurationRequest extends Request<IDeleteOIDCConfigurationParams, IResult> {
  constructor(idpConfigurationId: IDeleteOIDCConfigurationParams){
    super('deleteSiteOIDCConfiguration', idpConfigurationId);
  }
}